import { render } from "./document.vue?vue&type=template&id=43f704ab"
import script from "./document.vue?vue&type=script&lang=js"
export * from "./document.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__